import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tooltip"];
import React, { forwardRef } from 'react';
import SettingsIcon from '@atlaskit/icon/glyph/settings';
import { IconButton } from '../IconButton';
/**
 * __Settings__
 *
 * A settings button that can be passed into `AtlassianNavigation`'s `renderSettings` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#settings)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */
export var Settings = /*#__PURE__*/forwardRef(function (props, ref) {
  var tooltip = props.tooltip,
    iconButtonProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    role: "listitem"
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    icon: /*#__PURE__*/React.createElement(SettingsIcon, {
      label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
    }),
    ref: ref,
    tooltip: tooltip
  }, iconButtonProps)));
});
export default Settings;